export const maxQuantity = 999;

export const errorAdditionalInfo = (error: string, maxQuantity: number, minQuantity: number): string => {
    if (error === 'AdjustedQuantityByMaxQuantity' || error === 'AdjustedQuantityByBackorderQuantity') return ` ${maxQuantity}`;
    if (error === 'AdjustedQuantityByAvailableQuantity') return ` ${maxQuantity}`;
    if (error === 'AdjustedQuantityByMinQuantity') return ` ${minQuantity}`;

    return '';
};
